/** Factory the app uses. OWNER: VIEWMODEL+CAMERA agent (keep the name). */
import type { CameraController } from '../types';
import { FirstPersonCamera } from './camera';

export function createCamera(): CameraController {
  return new FirstPersonCamera();
}
